// ==============================|| OVERRIDES - AUTOCOMPLETE ||============================== //

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: '0px 0px',
          },
          '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
            padding: '8px 12px',
          },
          '&.MuiAutocomplete-sizeSmall .MuiOutlinedInput-root .MuiAutocomplete-input': {
            padding: '4px 12px',
          },
          '&.MuiAutocomplete-sizeLarge .MuiOutlinedInput-root .MuiAutocomplete-input': {
            padding: '12px',
          },
        },
        popupIndicator: {
          width: 'auto',
          height: 'auto',
          '&.Mui-disabled': {
            color: theme.palette.text.secondary,
          },
        },
        clearIndicator: {
          width: 'auto',
          height: 'auto',
        },
        tag: {
          backgroundColor: theme.palette.secondary.dark,
          color: theme.palette.text.primary,
          padding: 0,
          borderRadius: '10px',
          height: '20px',
          fontSize: '0.75rem',
          margin: '8px 3px',
          '&:first-child': {
            marginLeft: '12px',
          },
          '&:last-child': {
            marginRight: '12px',
          },
          '& .MuiChip-label': {
            padding: '0 8px',
          },
          '& .MuiChip-deleteIcon': {
            color: theme.palette.text.primary,
            fontSize: '10px',
          },
        },
        popper: {
          '& .MuiPaper-root': {
            border: `1px solid ${theme.palette.secondary.darker}`,
            color: theme.palette.text.secondary,
            boxShadow: theme.customShadows.inputShadow,
            backgroundColor: theme.palette.secondary.light,
          },
          '& .MuiAutocomplete-listbox': {
            padding: 0,
            '& .MuiAutocomplete-option': {
              color: theme.palette.text.secondary,
              backgroundColor: theme.palette.secondary.light,
              '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                color: theme.palette.text.primary,
              },
              '&.Mui-focused': {
                backgroundColor: theme.palette.secondary.dark,
                color: theme.palette.text.primary,
              },
              '&[aria-selected="true"]': {
                color: theme.palette.text.primary,
                backgroundColor: 'transparent',
                borderLeft: `3px solid ${theme.palette.primary.darker}`,
                '&:hover': {
                  backgroundColor: theme.palette.secondary.dark,
                },
              },
            },
          },
        },
      },
    },
  }
}
